import { render, staticRenderFns } from "./TestPost.vue?vue&type=template&id=158fe6f2"
import script from "./TestPost.vue?vue&type=script&lang=js"
export * from "./TestPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports